<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon="mdi-vector-link" desc="Sistemdeki link yönlendirmelerini yönetin">
          <template v-slot:title>
            <div class="mr-5">Link Yönlendirmeleri</div>
            <v-card class="mr-5" elevation="0">
              <v-btn
                color="blue accent-4"
                dark
                class="font-weight-medium"
                small
                @click="addRouterLinkDataDialog"
              >
                <v-icon class="mr-1" size="18">mdi-link-variant-plus</v-icon>Link Ekle
              </v-btn>
            </v-card>
            <v-card class="mr-5" elevation="0">
              <v-btn color="blue" dark small @click="routerLinkInfoDialog = true">
                <v-icon size="16" class="mr-1">mdi-information</v-icon>RouterLink Nedir ?
              </v-btn>
            </v-card>
          </template>
          <template v-slot:append-inner>
            <v-card class="mr-5" elevation="0">
              <v-select
                solo
                dense
                hide-details
                :items="moduleRoutersList"
                label="Modüle Göre Sırala"
                item-text="module"
                item-value="router"
                v-model="listRouter.routerType"
                clearable
                prepend-inner-icon="mdi-filter-variant"
              >
                <template v-slot:item="{ item }">
                  <span class="mr-1">{{item.module}}</span>
                  <sup class="grey--text text--darken-3">({{item.router}})</sup>
                </template>
              </v-select>
            </v-card>
            <v-card color="transparent" elevation="0">
              <v-text-field
                solo
                hint="Aramak için kelime girin ve Enter'a basın."
                dense
                label="Link'lerde ara"
                prepend-inner-icon="mdi-magnify"
                class="router-ara-text-field font-weight-light mb-0"
                v-model="routerAraData.routerAraText"
                @keyup.enter="routerAraEnter"
                clearable
                prefix="/"
              >
                <template v-slot:append>
                  <div class="d-flex align-center">
                    <v-btn
                      depressed
                      icon
                      class="router-ara-btn"
                      color="black"
                      @click="routerAraEnter"
                    >
                      <v-icon color="black">mdi-chevron-right</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-text-field>
            </v-card>
          </template>
        </panel-title>
      </v-col>
      <v-col cols="12">
        <v-data-table
          checkbox-color="black"
          v-model="selectedRouters"
          :items="routersList"
          :page.sync="tableParams.page"
          :items-per-page="list.limit"
          :headers="routersTable.headers"
          :no-data-text="routersTable.noDataText"
          calculate-widths
          hide-default-footer
          class="elevation-1 mb-3"
          @page-count="tableParams.pageCount = $event"
          :loading="tableParams.listStatus"
          :loading-text="routersTable.loadingText"
          :server-items-length="routersCount"
          :show-select="false"
        >
          <template v-slot:item.id="{ item }">
            <v-chip color="grey darken-3" label dark>{{getModuleName(item.router)}}</v-chip>
          </template>
          <template v-slot:item.link="{ item }">
            <span class="font-weight-medium mr-1">{{item.link[0] != '/' ? '/' : ''}}{{item.link}}</span>
            <sup>
              <v-tooltip bottom color="blue">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-if="item.routerlink"
                    v-on="on"
                    v-bind="attrs"
                    size="18"
                    color="blue"
                  >mdi-link</v-icon>
                </template>
                <span>RouterLink</span>
              </v-tooltip>
            </sup>
          </template>
          <template v-slot:item.router="{ item }">
            <v-chip color="grey lighten-2" label>
              <span class="font-weight-regular">{{item.router}}</span>
            </v-chip>
          </template>
          <template v-slot:item.code="{ item }">
            <v-btn
              x-small
              fab
              color="blue lighten-5"
              class="mr-2"
              depressed
              :loading="editRouterLinkData.reqLoading[item.link]"
              @click="editRouterLinkDialog(item.link)"
            >
              <v-icon color="blue">mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              x-small
              fab
              color="red lighten-5"
              depressed
              @click="removeRouterLinkDialog(item.link)"
            >
              <v-icon color="red darken-2">mdi-delete</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-model="pagination.page"
          :length="tableParams.pageCount"
          circle
          @input="pageClick"
        ></v-pagination>
      </v-col>
    </v-row>

    <!-- Add Router Link Start -->
    <v-dialog v-model="addRouterLinkData.dialog" max-width="500">
      <v-card>
        <v-card-title class="blue subtitle-1 white--text text--darken-4">
          <v-icon left color="white" size="20">mdi-close-octagon</v-icon>Yeni Link Ekle
        </v-card-title>
        <v-card-text class="grey lighten-3 pb-0">
          <v-row>
            <v-col cols="12" lg="6">
              <v-text-field
                prefix="/"
                prepend-inner-icon="mdi-link-variant"
                dense
                solo
                hide-details
                label="Link"
                v-model="addRouterLinkData.link"
                @input="generateRouterLink(addRouterLinkData.link)"
                :loading="seoUrlStatus"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="6">
              <v-select
                prepend-inner-icon="mdi-vector-link"
                dense
                solo
                :items="moduleRoutersList"
                v-model="addRouterLinkData.router"
                label="Router"
                item-text="router"
                item-value="router"
                hide-details
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" text @click="addRouterLinkData.dialog = false">İptal</v-btn>
          <v-btn
            small
            color="blue"
            :loading="addRouterLinkData.loading"
            dark
            @click="addRouterLink"
            :disabled="seoUrlStatus"
          >
            <v-icon size="18" class="mr-1">mdi-link-variant-plus</v-icon>Ekle
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add Router Link End -->

    <!-- Edit Router Link Start -->
    <v-dialog v-model="editRouterLinkData.dialog" max-width="500">
      <v-card>
        <v-card-title class="blue subtitle-1 white--text text--darken-4">
          <v-icon left color="white" size="20">mdi-close-octagon</v-icon>Yeni Link Ekle
        </v-card-title>
        <v-card-text class="grey lighten-3 pb-0">
          <v-row>
            <v-col cols="12" lg="6">
              <v-text-field
                prefix="/"
                prepend-inner-icon="mdi-link-variant"
                dense
                solo
                hide-details
                label="Link"
                v-model="editRouterLinkData.update"
                @input="generateRouterLink(editRouterLinkData.update)"
                :loading="seoUrlStatus"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="6">
              <v-select
                prepend-inner-icon="mdi-vector-link"
                dense
                solo
                :items="moduleRoutersList"
                :value="editRouterLinkData.router"
                label="Router"
                item-text="router"
                item-value="router"
                hide-details
                disabled
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="red darken-1" text @click="editRouterLinkData.dialog = false">İptal</v-btn>
          <v-btn
            small
            color="success"
            :loading="editRouterLinkData.loading"
            dark
            @click="editRouterLink"
            :disabled="seoUrlStatus"
          >
            <v-icon size="18" class="mr-1">mdi-link-variant-plus</v-icon>Güncelle
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Edit Router Link End -->

    <!-- Delete Router Link Start -->
    <v-dialog v-model="removeRouterLinkData.dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>Uyarı
        </v-card-title>
        <v-card-text>Seçili link'i sistemden kaldırmak istediğinize emin misiniz ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="removeRouterLinkData.dialog = false">İptal</v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="removeRouterLinkData.loading"
            @click="removeRouterLink"
          >Evet</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Delete Router Link End -->

    <!-- Router Link Info Start -->
    <v-dialog v-model="routerLinkInfoDialog" max-width="500">
      <v-alert type="info" class="mb-0">
        <strong class="text-h6 d-block mb-3">RouterLink Nedir ?</strong>
        <p>Bu panel üzerinden doğrudan eklenen linklerdir. Geriye kalan link'ler modüllerin kendi ekledikleridir.</p>
        <p>Normal bir link'i kaldırdığınızda/güncellediğinizde sistem modül üzerindeki bağlantıya da aynı işlemi zorlar ve günceller veya kaldırıldığında 'null' olarak ayarlar.</p>
        <p>Modül üzerindeki link'e de işlem yapabilmek için bağlantılar ilgili router'da kayıtlı bileşen tablosunda bulunmalıdır.</p>
      </v-alert>
    </v-dialog>
    <!-- Router Link Info End -->
  </v-container>
</template>

<script>
import PanelTitle from "../../../components/PanelTitle.vue";
import { mapState } from "vuex";
import ModuleService from "@/services/ModuleService";
import RouterService from "@/services/RouterService";

export default {
  name: "DeveloperRouters",
  components: { PanelTitle },
  data: () => ({
    routersTable: {
      headers: [
        { text: "Module", value: "id", sortable: false},
        { text: "Link", value: "link", sortable: false },
        { text: "Router", value: "router", sortable: false, align: "center" },
        { text: "İşlemler", value: "code", sortable: false }
      ],
      noDataText: "Görüntülenecek yazı bulunmuyor",
      loadingText: "Yükleniyor... Lütfen Bekleyin"
    },
    selectedRouters: [],
    pagination: {
      page: 1,
      lastPage: 0
    },
    tableParams: {
      page: 1,
      pageCount: 0,
      listStatus: true
    },
    list: {
      start: 0,
      limit: 10,
      order: "desc"
    },
    listStatus: true,
    yaziKaldir: {
      yaziCode: 0,
      dialog: false,
      loading: false
    },
    routerAraData: {
      routerAraSelect: "",
      routerAraText: null,
      routerAraType: "name"
    },
    listRouter: {
      routerType: null
    },
    moduleRoutersList: [],
    addRouterLinkData: {
      link: "",
      router: "",
      dialog: false,
      loading: false
    },
    editRouterLinkData: {
      link: "",
      update: "",
      router: "",
      dialog: false,
      loading: false,
      reqLoading: {}
    },
    removeRouterLinkData: {
      link: "",
      dialog: false,
      loading: false
    },
    linkMap: {},
    seoUrlTimeout: null,
    seoUrlStatus: false,
    routerLinkInfoDialog: false
  }),
  computed: {
    /**
     * @returns {Object}
     */
    ...mapState({
      routersList: state => state.Router.routersList,
      routersCount: state => state.Router.routersCount
    })
  },
  methods: {
    pageClick(page) {
      if (page !== this.pagination.lastPage) {
        /**
         * Başlangıç değerini pagination'a göre ayarla
         */
        this.list.start =
          this.pagination.page * this.list.limit - this.list.limit;

        if (!this.routerAraData.routerAraText) {
          /**
           * Ürün listesini getir
           */
          this.getRoutersList();
        } else {
          /**
           * Arama var ise aramaya göre pagination getir
           */

          /**
           * Ürünü aram sonucunu pagination'a göre getir
           */
          this.routerAra();
        }
      }
    },
    generateRouterLink(link) {
      this.seoUrlStatus = true;
      if (this.seoUrlTimeout) {
        clearTimeout(this.seoUrlTimeout);
      }
      this.seoUrlTimeout = setTimeout(() => {
        RouterService.seoUrl({ link }).then(res => {
          if (res.status === 200) {
            if (this.addRouterLinkData.dialog) {
              this.addRouterLinkData.link = res.data;
            } else if (this.editRouterLinkData.dialog) {
              this.editRouterLinkData.update = res.data;
            }
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        });
        this.seoUrlTimeout = null;
        this.seoUrlStatus = false;
      }, 500);
    },
    getRoutersList() {
      const { start, limit, order } = this.list;
      this.listStatus = true;
      return this.$store
        .dispatch("Router/getRoutersList", {
          start,
          limit,
          order
        })
        .then(res => {
          this.tableParams.listStatus = false;
          this.pagination.paginationLength = res.data.count;
          return res;
        })
        .then(res => {
          if (res.data.list.length === 0 && this.pagination.page > 1) {
            this.pageClick((this.pagination.page -= 1));
          }
        })
        .then(() => {
          this.listStatus = false;
        });
    },
    routerAraEnter() {
      if (this.routerAraData.routerAraText !== "") {
        this.paginationSifirla();
      }
      this.routerAra();
    },
    routerAra() {
      const link = this.routerAraData.routerAraText;
      const router = this.listRouter.routerType;
      const { start, limit, order } = this.list;
      this.listStatus = true;
      return this.$store
        .dispatch("Router/getRoutersList", {
          link,
          router,
          start,
          limit,
          order
        })
        .then(res => {
          this.listStatus = false;
          if (res.status !== 200) {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
          return res;
        })
        .then(res => {
          if (res.data.list.length === 0 && this.pagination.page > 1) {
            this.pageClick((this.pagination.page -= 1));
          }
        });
    },
    paginationSifirla() {
      this.$store.commit("Router/setRoutersList", []);
      this.$store.commit("Router/setRoutersCount", 0);
      this.list.start = 0;
      this.pagination.page = 1;
    },
    getModuleName(routerName) {
      let router = this.moduleRoutersList.find(l => l.router == routerName);
      if (router) {
        return router.module;
      } else {
        return "";
      }
    },
    addRouterLinkDataDialog() {
      this.addRouterLinkData.dialog = true;
    },
    addRouterLink() {
      const { link, router } = this.addRouterLinkData;
      this.addRouterLinkData.loading = true;
      RouterService.addRouterLink({ link, router })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success("Link başarıyla eklenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
            this.getRoutersList();
            this.addRouterLinkData.dialog = false;
            this.addRouterLinkData.link = "";
            this.addRouterLinkData.router = "";
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        })
        .then(() => {
          this.addRouterLinkData.loading = false;
        });
    },
    editRouterLinkDialog(link) {
      this.$set(this.editRouterLinkData.reqLoading, link, true);
      RouterService.getRouterLink(link)
        .then(res => {
          if (res.status === 200) {
            this.editRouterLinkData.dialog = true;
            this.editRouterLinkData.link = res.data.link;
            this.editRouterLinkData.update = res.data.link;
            this.editRouterLinkData.router = res.data.router;
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        })
        .then(() => {
          this.$set(this.editRouterLinkData.reqLoading, link, false);
        });
    },
    editRouterLink() {
      const { link, update } = this.editRouterLinkData;
      this.editRouterLinkData.loading = true;
      RouterService.updateRouterLink({ link, update })
        .then(res => {
          if (res.status === 200) {
            this.editRouterLinkData.dialog = false;
            this.getRoutersList();
            this.$snotify.success("Link güncellenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        })
        .then(() => {
          this.editRouterLinkData.loading = false;
        });
    },
    removeRouterLinkDialog(link) {
      this.removeRouterLinkData.link = link;
      this.removeRouterLinkData.dialog = true;
    },
    removeRouterLink() {
      const link = this.removeRouterLinkData.link;
      this.removeRouterLinkData.loading = true;
      RouterService.removeRouterLink(link)
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success("Link sistemden kaldırılmıştır", this.$t('PANEL.NOTIFY.SUCCESS'));
            this.removeRouterLinkData.dialog = false;
            this.getRoutersList();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
        })
        .then(() => {
          this.removeRouterLinkData.loading = false;
        });
    }
  },
  created() {
    ModuleService.getRoutersList()
      .then(res => {
        if (res.status === 200) {
          this.moduleRoutersList = res.data.filter(r => r.route);
        }
      })
      .then(() => {
        this.getRoutersList().then(() => {
          this.routersList.forEach(l => {
            this.linkMap[l.link] = false;

            this.editRouterLinkData.reqLoading = Object.assign(
              this.linkMap,
              {}
            );
          });
        });
      });
  },
  watch: {
    /**
     * @returns {Void}
     */
    "pagination.page": {
      handler(page) {
        this.pagination.lastPage = page;
      },
      immediate: true
    },
    "routerAraData.routerAraText"(val) {
      if (!val) {
        this.list.start = 0;
        this.getRoutersList();
        this.routerAraData.routerAraSelect = "";
        // Clearable'da null'a çevirmekte, null dönerse "" at
        this.routerAraData.routerAraText = val ?? "";
      }
    },
    "listRouter.routerType"(val) {
      if (this.listRouter.routerType === undefined) {
        this.listRouter.routerType = null;
      } else {
        this.routerAra();
      }
    }
  }
};
</script>

<style>
.router-ara-text-field.v-text-field .v-input__slot {
  margin-bottom: 0;
}
.router-ara-text-field.v-text-field {
  position: relative;
}
.router-ara-text-field.v-text-field .v-text-field__details {
  position: absolute;
  left: -10px;
  top: -18px;
  margin-bottom: 0;
  height: 0;
  width: 100%;
}
</style>